import React, { useEffect, useState } from "react"
import DfbSpinner from "../ui-kit/dfb_spinner"
import MUserPanel from "../blocks/m_user_panel"
import MUserPanelContent from "../blocks/m_user_panel_content"
import MUserPanelAccordion, { StatusColor } from "../blocks/m_user_panel_accordion"
import { getTasks, TaskStatus } from "../../services/education"
import ServiceError from "../../services/ServiceError"
import { formatDate } from "../utilities"
import content from "../../content"
import { useCoachLearningPlatformUrl } from "../../hooks/headerLinks/coachLearningPlatform"

const statusColors = {
  [TaskStatus.OPEN_IN_FUTURE]: StatusColor.GREY,
  [TaskStatus.OPEN_CURRENT]: StatusColor.ORANGE,
  [TaskStatus.STARTED]: StatusColor.ORANGE,
  [TaskStatus.EVALUATION_PENDING]: StatusColor.GREEN,
  [TaskStatus.COMPLETED]: StatusColor.GREEN,
  [TaskStatus.REJECTED]: StatusColor.RED,
  [TaskStatus.UNKNOWN]: StatusColor.GREY,
}

const MUserTasks = ({ headline }) => {
  const [items, setItems] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const campusUrl = useCoachLearningPlatformUrl()

  const getAccordionItem = task => {
    const start = formatDate(task.start)
    const end = formatDate(task.end)
    return {
      title: task.assignmentName,
      status: statusColors[task.status.key],
      buttonLabel: content.userPanels.tasks.taskList.button,
      buttonLink: task.url,
      columns: [
        {
          key: content.userPanels.tasks.taskList.columns.courseName,
          value: task.courseName,
        },
        {
          key: content.userPanels.tasks.taskList.columns.date,
          value: `${start} - ${end}`,
        },
        {
          key: content.userPanels.tasks.taskList.columns.status,
          value: task.status.label,
        },
      ],
    }
  }

  const handleApiError = err => {
    if (err.statusCode === ServiceError.STATUS_UNAUTHORIZED) {
      setErrorMessage(content.userPanels.tasks.error.unauthorized)
    } else {
      setErrorMessage(content.global.error.apiError)
    }
  }

  const initTasks = async () => {
    try {
      const tasks = await getTasks()
      setItems(tasks.map(getAccordionItem))
    } catch (err) {
      handleApiError(err)
    }
  }

  useEffect(() => {
    initTasks()
  }, [])

  return (
    <MUserPanel headline={headline} errorMessage={errorMessage}>
      {items && items.length > 0 && <MUserPanelAccordion items={items} statusColumnIndex={2} />}
      {items && items.length === 0 && (
        <MUserPanelContent
          headline={content.userPanels.tasks.noTasks.headline}
          richtext={content.userPanels.tasks.noTasks.richtext}
          buttonLabel={content.userPanels.tasks.noTasks.button}
          buttonLink={campusUrl}
        />
      )}
      {!items && !errorMessage && <DfbSpinner type="continuous" autoLoop={true} />}
    </MUserPanel>
  )
}

export default MUserTasks
